import { useState } from "react";
import Reveal from "./Reveal";
import SectionLabel from "./SectionLabel";

const GithubIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

const LeetCodeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104 5.35 5.35 0 0 0-.125.513 5.527 5.527 0 0 0 .062 2.362 5.83 5.83 0 0 0 .349 1.017 5.938 5.938 0 0 0 1.271 1.818l4.277 4.193.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523 2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0zm-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382 1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382 1.38 1.38 0 0 0-1.38-1.382z" />
  </svg>
);

const ResumeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);

const SOCIAL = [
  { label: "GitHub", href: "https://github.com/upskill-hamza", icon: <GithubIcon /> },
  { label: "LinkedIn", href: "https://linkedin.com/in/hamza-ansari-1240ab2b7", icon: <LinkedInIcon /> },
  { label: "LeetCode", href: "https://leetcode.com/u/HamzaUpskill", icon: <LeetCodeIcon /> },
  { label: "Resume", href: "/Hamza_Resume.pdf", icon: <ResumeIcon />, type: "resume" },
];

function SocialLink({ label, href, icon, type }) {
  const [hov, setHov] = useState(false);
  const isResume = type === "resume";

  return (
    <a
      href={href}
      target={isResume ? "_self" : "_blank"}
      rel="noopener noreferrer"
      download={isResume ? "Hamza_Ansari_Resume.pdf" : undefined}
      className="hoverable"
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontFamily: "'DM Mono', monospace",
        fontSize: "12px",
        color: hov ? "#00e5ff" : "#5a6475",
        textDecoration: "none",
        padding: "12px 20px",
        border: `1px solid ${hov ? "#00e5ff" : "#1a2030"}`,
        background: hov ? "rgba(0,229,255,0.04)" : "transparent",
        transition: "all 0.2s",
        letterSpacing: "0.05em",
      }}
    >
      {icon} {label}
    </a>
  );
}

export default function Contact() {
  return (
    <section
      id="contact"
      style={{
        padding: "clamp(60px, 10vw, 120px) clamp(24px, 5vw, 48px)",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "radial-gradient(ellipse 60% 60% at 50% 50%, rgba(0,229,255,0.06), transparent)",
          pointerEvents: "none",
        }}
      />

      <Reveal>
        <div
          style={{
            position: "relative",
            maxWidth: "700px",
            margin: "0 auto",
          }}
        >
          <SectionLabel center>Let's Connect</SectionLabel>

          <h2
            style={{
              fontSize: "clamp(48px,7vw,88px)",
              fontWeight: 800,
              letterSpacing: "-3px",
              lineHeight: 0.95,
              marginBottom: "24px",
            }}
          >
            Say
            <br />
            <span
              style={{
                WebkitTextStroke: "1.5px rgba(255,255,255,0.2)",
                color: "transparent",
              }}
            >
              Hello
            </span>
          </h2>

          <p
            style={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "13px",
              color: "#5a6475",
              marginBottom: "48px",
              lineHeight: 1.7,
            }}
          >
            I'm always open to new opportunities, collaborations, and interesting conversations.
            Whether it's an internship, a project, or just a chat about tech — reach out!
          </p>

          <a
            href="mailto:hamzamohd60329@gmail.com"
            className="btn-primary hoverable"
            style={{
              display: "inline-block",
              marginBottom: "48px",
            }}
          >
            Send a Message
          </a>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "24px",
              flexWrap: "wrap",
            }}
          >
            {SOCIAL.map((s) => (
              <SocialLink key={s.label} {...s} />
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
}